// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2KmF-","title":"Images45_title__2BN_M","images":"Images45_images__3UPe_"};